import { z } from 'zod';
export const InlineDataSchema = z.object({
    mimeType: z.string(),
    data: z.string().min(1),
});
export const PartSchema = z.union([
    z.object({ text: z.string() }),
    z.object({ inlineData: InlineDataSchema }),
]);
export const ContentItemSchema = z.object({
    role: z.enum(['user', 'model', 'system', 'assistant']).optional(),
    parts: z.array(PartSchema),
});
export const GenerationConfigSchema = z.object({
    responseMimeType: z.string().optional(),
    responseSchema: z.any().optional(),
    temperature: z.number().optional(),
    maxOutputTokens: z.number().optional(),
    topP: z.number().optional(),
    topK: z.number().optional(),
}).partial();
export const SystemInstructionSchema = z.object({
    parts: z.array(z.object({ text: z.string() })),
}).optional();
export const AiRequestSchema = z.object({
    model: z.string().min(1, 'Modelo é obrigatório'),
    contents: z.array(ContentItemSchema).min(1, 'Pelo menos um item em contents é obrigatório'),
    config: GenerationConfigSchema.optional(),
    systemInstruction: SystemInstructionSchema,
});
